// import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
// import { getEmojiDataFromNative } from 'emoji-mart';
//Mui imports
import Popover from '@mui/material/Popover';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { IconButton } from '@mui/material';
import { useState } from 'react';
// import supportedUTF8HexToEmoji from './supportedUTF8HexToEmoji.json';
import { unsupportedUTF8HexToEmoji } from './unspportedUTF8HexToEmoji';

const Emojis = ({ setOpen, setChimeContent, chimeContent }) => {
    const handleClick = async (e) => {
        // console.log(chimeContent + e.native);
        setChimeContent(chimeContent + e.native)
        setOpen(false)
    }

    return (
        <Picker
            exceptEmojis={unsupportedUTF8HexToEmoji}
            icons='icons'
            theme='auto'
            onEmojiSelect={handleClick}
            previewPosition='none'
            noCountryFlags='true'
            emojiVersion='1'
            perLine='7'
            maxFrequentRows='1'
            skinTonePosition='none'
        />
    );
}

export const Emoji = ({ setChimeContent, chimeContent }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(false);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <div className="emoji-picker-icon">
            <IconButton aria-describedby={id} variant="contained" onClick={handleClick}>
                <EmojiEmotionsIcon id="emoji-icon" />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                sx={{zIndex:'100001'}}
            >
                <Emojis setOpen={setAnchorEl} setChimeContent={setChimeContent} chimeContent={chimeContent} />
            </Popover>
        </div>
    )
}